export const buttonHeights = {
    xsmall: 2,
    small: 2.25,
    medium: 2.5,
    large: 3,
    xlarge: 3.75,
};
